import {connect} from "react-redux";

import Messages from "../../../../components/Chat/ChatBot/Messages/Messages";
import {setSelectedDay} from "../../../../actions/PlanDemand";

const MapStateToProps = (state) => ({
messages: state.planDemand.messages,
selectedDay: state.planDemand.selectedDay,
disableDatePicker: state.planDemand.disableDatePicker,
botIsLoading: state.planDemand.botIsLoading
});

const MapDispatchToProps = (dispatch) => ({
setSelectedDay: (day) => {
dispatch(setSelectedDay(day));
},
});

export default connect(MapStateToProps, MapDispatchToProps)(Messages);